export interface InflcrAppConfig {
	helpCenterUrl: string;
}

export default <InflcrAppConfig> {
	helpCenterUrl: 'https://tw.app',
};
